import Vue from 'vue';
import store from '@/store';
import $ from 'jquery'

import AddPricetypeModal from './AddPricetypeModal.vue';

export default function(){
    let element = $(`<div id="gnzs-1c-amo__add-pricetype-modal-container"></div>`)
    $('body').append(element)

    new Vue({
        store,
        render: h => h(AddPricetypeModal)
    }).$mount('#gnzs-1c-amo__add-pricetype-modal-container');
}